import { render, staticRenderFns } from "./useFund.vue?vue&type=template&id=6cbc6794&scoped=true"
import script from "./useFund.vue?vue&type=script&lang=js"
export * from "./useFund.vue?vue&type=script&lang=js"
import style0 from "./useFund.vue?vue&type=style&index=0&id=6cbc6794&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbc6794",
  null
  
)

export default component.exports